export default {
  LIGHT_CR: 3,
  ACCEPTABLE_LIGHT_CR: 3.5,
  ACCEPTABLE_DARK_CR: 4.5,
};
